export type UserLocation = Partial<{
  region: LocationRegion;
  country: LocationCountry;
  locale: string;
  currency: string;
  currencySymbol: string;
}>;

export enum LocationRegion {
  CALIFORNIA = 'CA',
}

export enum LocationCountry {
  US = 'US',
  UA = 'UA',
  AE = 'AE',
  AL = 'AL',
  AT = 'AT',
  AU = 'AU',
  BG = 'BG',
  BE = 'BE',
  CA = 'CA',
  CH = 'CH',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DK = 'DK',
  GB = 'GB',
  GR = 'GR',
  IE = 'IE',
  IT = 'IT',
  IS = 'IS',
  ME = 'ME',
  HR = 'HR',
  HU = 'HU',
  EE = 'EE',
  ES = 'ES',
  LI = 'LI',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  MK = 'MK',
  MT = 'MT',
  NL = 'NL',
  NO = 'NO',
  PL = 'PL',
  PT = 'PT',
  RO = 'RO',
  RS = 'RS',
  SI = 'SI',
  SK = 'SK',
  FI = 'FI',
  FR = 'FR',
  SE = 'SE',
  ZA = 'ZA',
  CN = 'CN',
  HK = 'HK',
  SG = 'SG',
}
